/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2020
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import ObjectType from './ObjectType';
import MoserObject from './MoserObject';
import InstanceType from './InstanceType';
import UsageType from './UsageType';
import RegularAggregateType from './RegularAggregateType';
import HighLevelDataType from './HighLevelDataType';
import SourceCategoryType from './SourceCategoryType';
import AggregateMode from './AggregateMode';
import RoleType from './RoleType';
//@import com/ibm/bi/platform/moser/common/generated/metadata/ObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (runtime) // updatePropertyOverride
//@import com/ibm/bi/platform/moser/common/generated/metadata/InstanceType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/UsageType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/RegularAggregateType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/HighLevelDataType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/SourceCategoryType (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/AggregateMode (runtime) // new
//@import com/ibm/bi/platform/moser/common/generated/metadata/RoleType (runtime) // new

/**
 * <p>Java class for baseQueryItemType complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType name="baseQueryItemType"&gt; &lt;complexContent&gt; &lt;extension base="{}objectType"&gt; &lt;sequence&gt; &lt;group ref="{}queryItemGroup"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class BaseQueryItemType extends ObjectType{

	expression = null;

	ref = null;

	instanceType = null;

	usage = null;

	format = null;

	datatype = null;

	nullable = null;

	regularAggregate = null;

	datatypeCategory = null;

	highlevelDatatype = null;

	facetDefinition = null;

	taxonomy = null;

	splitDefinition = null;

	sourceCategory = null;

	item = null;

	aggregateMode = null;

	role = null;

	promptInfo = null;

	_referencedObject = null;



	/**
	 * Gets the value of the expression property.
	 * @return {String} possible object is {@link String}
	 */
	getExpression() {
		return this.expression;
	}

	/**
	 * Sets the value of the expression property.
	 * @param {String} value allowed object is {@link String}
	 */
	setExpression(value) {
		var oldValue = this.expression;
		this.expression = value;
		this._setAndNotify(43, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the ref property.
	 * @return {String} possible object is {@link String}
	 */
	getRef() {
		return this.ref;
	}

	/**
	 * Sets the value of the ref property.
	 * @param {String} value allowed object is {@link String}
	 */
	setRef(value) {
		var oldValue = this.ref;
		this.ref = value;
		this._setAndNotify(36, oldValue, value, false, true);
		this._referencedObject = null;
	}

	/**
	 * Gets the value of the instanceType property.
	 * @return {InstanceType} possible object is {@link InstanceType}
	 */
	getInstanceType() {
		return this.instanceType;
	}

	/**
	 * Sets the value of the instanceType property.
	 * @param {InstanceType} value allowed object is {@link InstanceType}
	 */
	setInstanceType(value) {
		var oldValue = this.instanceType;
		this.instanceType = value;
		this._setAndNotify(58, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the usage property.
	 * @return {UsageType} possible object is {@link UsageType}
	 */
	getUsage() {
		return this.usage;
	}

	/**
	 * Sets the value of the usage property.
	 * @param {UsageType} value allowed object is {@link UsageType}
	 */
	setUsage(value) {
		var oldValue = this.usage;
		this.usage = value;
		this._setAndNotify(77, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the format property.
	 * @return {String} possible object is {@link String}
	 */
	getFormat() {
		return this.format;
	}

	/**
	 * Sets the value of the format property.
	 * @param {String} value allowed object is {@link String}
	 */
	setFormat(value) {
		var oldValue = this.format;
		this.format = value;
		this._setAndNotify(245, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the datatype property.
	 * @return {String} possible object is {@link String}
	 */
	getDatatype() {
		return this.datatype;
	}

	/**
	 * Sets the value of the datatype property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatatype(value) {
		var oldValue = this.datatype;
		this.datatype = value;
		this._setAndNotify(64, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the nullable property.
	 * @return {Boolean} possible object is {@link Boolean}
	 */
	isNullable() {
		return this.nullable;
	}

	/**
	 * Sets the value of the nullable property.
	 * @param {Boolean} value allowed object is {@link Boolean}
	 */
	setNullable(value) {
		var oldValue = this.nullable;
		this.nullable = value;
		this._setAndNotify(74, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the regularAggregate property.
	 * @return {RegularAggregateType} possible object is {@link RegularAggregateType}
	 */
	getRegularAggregate() {
		return this.regularAggregate;
	}

	/**
	 * Sets the value of the regularAggregate property.
	 * @param {RegularAggregateType} value allowed object is {@link RegularAggregateType}
	 */
	setRegularAggregate(value) {
		var oldValue = this.regularAggregate;
		this.regularAggregate = value;
		this._setAndNotify(78, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the datatypeCategory property.
	 * @return {String} possible object is {@link String}
	 */
	getDatatypeCategory() {
		return this.datatypeCategory;
	}

	/**
	 * Sets the value of the datatypeCategory property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatatypeCategory(value) {
		var oldValue = this.datatypeCategory;
		this.datatypeCategory = value;
		this._setAndNotify(250, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the highlevelDatatype property.
	 * @return {HighLevelDataType} possible object is {@link HighLevelDataType}
	 */
	getHighlevelDatatype() {
		return this.highlevelDatatype;
	}

	/**
	 * Sets the value of the highlevelDatatype property.
	 * @param {HighLevelDataType} value allowed object is {@link HighLevelDataType}
	 */
	setHighlevelDatatype(value) {
		var oldValue = this.highlevelDatatype;
		this.highlevelDatatype = value;
		this._setAndNotify(75, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the facetDefinition property.
	 * @return {FacetType} possible object is {@link FacetType}
	 */
	getFacetDefinition() {
		return this.facetDefinition;
	}

	/**
	 * Sets the value of the facetDefinition property.
	 * @param {FacetType} value allowed object is {@link FacetType}
	 */
	setFacetDefinition(value) {
		var oldValue = this.facetDefinition;
		this.facetDefinition = value;
		this._setAndNotify(249, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the taxonomy property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the taxonomy property. <p> For example, to add a new item, do as follows: <pre> getTaxonomy().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link TaxonomyType}
	 */
	getTaxonomy() {
		if (!this.taxonomy) {
			this.taxonomy = [];
		}
		return this.taxonomy;
	}

	/**
	 * Gets the value of the splitDefinition property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the splitDefinition property. <p> For example, to add a new item, do as follows: <pre> getSplitDefinition().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link SplitType}
	 */
	getSplitDefinition() {
		if (!this.splitDefinition) {
			this.splitDefinition = [];
		}
		return this.splitDefinition;
	}

	/**
	 * Gets the value of the sourceCategory property.
	 * @return {SourceCategoryType} possible object is {@link SourceCategoryType}
	 */
	getSourceCategory() {
		return this.sourceCategory;
	}

	/**
	 * Sets the value of the sourceCategory property.
	 * @param {SourceCategoryType} value allowed object is {@link SourceCategoryType}
	 */
	setSourceCategory(value) {
		var oldValue = this.sourceCategory;
		this.sourceCategory = value;
		this._setAndNotify(46, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the item property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the item property. <p> For example, to add a new item, do as follows: <pre> getItem().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link ItemType}
	 */
	getItem() {
		if (!this.item) {
			this.item = [];
		}
		return this.item;
	}

	/**
	 * Gets the value of the aggregateMode property.
	 * @return {AggregateMode} possible object is {@link AggregateMode}
	 */
	getAggregateMode() {
		return this.aggregateMode;
	}

	/**
	 * Sets the value of the aggregateMode property.
	 * @param {AggregateMode} value allowed object is {@link AggregateMode}
	 */
	setAggregateMode(value) {
		var oldValue = this.aggregateMode;
		this.aggregateMode = value;
		this._setAndNotify(247, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the role property.
	 * @return {RoleType} possible object is {@link RoleType}
	 */
	getRole() {
		return this.role;
	}

	/**
	 * Sets the value of the role property.
	 * @param {RoleType} value allowed object is {@link RoleType}
	 */
	setRole(value) {
		var oldValue = this.role;
		this.role = value;
		this._setAndNotify(244, oldValue, value, false, true);
	}

	/**
	 * Gets the value of the promptInfo property.
	 * @return {PromptInfoType} possible object is {@link PromptInfoType}
	 */
	getPromptInfo() {
		return this.promptInfo;
	}

	/**
	 * Sets the value of the promptInfo property.
	 * @param {PromptInfoType} value allowed object is {@link PromptInfoType}
	 */
	setPromptInfo(value) {
		var oldValue = this.promptInfo;
		this.promptInfo = value;
		this._setAndNotify(251, oldValue, value, true, true);
	}

	/**
	 * Gets the value of the <code>taxonomy</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>TaxonomyType</code> elements, or <code>null</code> if not set
	 */
	basicGetTaxonomy() {
		return this.taxonomy;
	}

	/**
	 * Gets the value of the <code>splitDefinition</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>SplitType</code> elements, or <code>null</code> if not set
	 */
	basicGetSplitDefinition() {
		return this.splitDefinition;
	}

	/**
	 * Gets the value of the <code>item</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>ItemType</code> elements, or <code>null</code> if not set
	 */
	basicGetItem() {
		return this.item;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTaxonomyAt(position, item) {
		this._addAtAndNotify(this.getTaxonomy(), position, item, 246, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTaxonomy(item) {
		this.addTaxonomyAt(this.getTaxonomy().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTaxonomyAt(position) {
		this._removeAtAndNotify(this.getTaxonomy(), position, 246, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTaxonomy(item) {
		var i = this.getTaxonomy().indexOf(item);
		if (i >= 0) {
			this.removeTaxonomyAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addSplitDefinitionAt(position, item) {
		this._addAtAndNotify(this.getSplitDefinition(), position, item, 248, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addSplitDefinition(item) {
		this.addSplitDefinitionAt(this.getSplitDefinition().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeSplitDefinitionAt(position) {
		this._removeAtAndNotify(this.getSplitDefinition(), position, 248, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeSplitDefinition(item) {
		var i = this.getSplitDefinition().indexOf(item);
		if (i >= 0) {
			this.removeSplitDefinitionAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addItemAt(position, item) {
		this._addAtAndNotify(this.getItem(), position, item, 3, true, false);
		var qi = item.getQueryItem();
		if (qi) {
			MoserObject.updatePropertyOverride(qi, this, 28, true);
		}
		var hierarchy = item.getItemHierarchy();
		if (hierarchy) {
			MoserObject.updatePropertyOverride(hierarchy, this, 27, true);
		}
		var namedSet = item.getNamedSet();
		if (namedSet) {
			MoserObject.updatePropertyOverride(namedSet, this, 26, true);
		}
		var filter = item.getFilter();
		if (filter) {
			MoserObject.updatePropertyOverride(filter, this, 24, true);
		}
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addItem(item) {
		this.addItemAt(this.getItem().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeItemAt(position) {
		this._removeAtAndNotify(this.getItem(), position, 3, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeItem(item) {
		var i = this.getItem().indexOf(item);
		if (i >= 0) {
			this.removeItemAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "BaseQueryItemType";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 43, "expression", null));
		featureList.push(this.createFeature(false, false, false, 36, "ref", null));
		featureList.push(this.createFeature(false, true, false, 58, "instanceType", InstanceType));
		featureList.push(this.createFeature(false, true, false, 77, "usage", UsageType));
		featureList.push(this.createFeature(false, false, false, 245, "format", null));
		featureList.push(this.createFeature(false, false, false, 64, "datatype", null));
		featureList.push(this.createFeature(false, false, false, 74, "nullable", null));
		featureList.push(this.createFeature(false, true, false, 78, "regularAggregate", RegularAggregateType));
		featureList.push(this.createFeature(false, false, false, 250, "datatypeCategory", null));
		featureList.push(this.createFeature(false, true, false, 75, "highlevelDatatype", HighLevelDataType));
		var clazz;
		if (factory) {
			clazz = factory.createFacetType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 249, "facetDefinition", clazz));
		if (factory) {
			clazz = factory.createTaxonomyType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 246, "taxonomy", clazz));
		if (factory) {
			clazz = factory.createSplitType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 248, "splitDefinition", clazz));
		featureList.push(this.createFeature(false, true, false, 46, "sourceCategory", SourceCategoryType));
		if (factory) {
			clazz = factory.createItemType().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 3, "item", clazz));
		featureList.push(this.createFeature(false, true, false, 247, "aggregateMode", AggregateMode));
		featureList.push(this.createFeature(false, true, false, 244, "role", RoleType));
		if (factory) {
			clazz = factory.createPromptInfoType().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 251, "promptInfo", clazz));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 43:
			this.setExpression((value));
			break;
		case 244:
			this.setRole((value));
			break;
		case 74:
			this.setNullable((value));
			break;
		case 46:
			this.setSourceCategory((value));
			break;
		case 75:
			this.setHighlevelDatatype((value));
			break;
		case 58:
			this.setInstanceType((value));
			break;
		case 77:
			this.setUsage((value));
			break;
		case 245:
			this.setFormat((value));
			break;
		case 247:
			this.setAggregateMode((value));
			break;
		case 36:
			this.setRef((value));
			break;
		case 64:
			this.setDatatype((value));
			break;
		case 78:
			this.setRegularAggregate((value));
			break;
		case 249:
			this.setFacetDefinition((value));
			break;
		case 250:
			this.setDatatypeCategory((value));
			break;
		case 251:
			this.setPromptInfo((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 3:
			this.item = (value);
			break;
		case 246:
			this.taxonomy = (value);
			break;
		case 248:
			this.splitDefinition = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 3:
			return this.getItem();
		case 43:
			return this.getExpression();
		case 244:
			return this.getRole();
		case 74:
			return this.isNullable();
		case 46:
			return this.getSourceCategory();
		case 75:
			return this.getHighlevelDatatype();
		case 58:
			return this.getInstanceType();
		case 77:
			return this.getUsage();
		case 245:
			return this.getFormat();
		case 246:
			return this.getTaxonomy();
		case 247:
			return this.getAggregateMode();
		case 36:
			return this.getRef();
		case 64:
			return this.getDatatype();
		case 248:
			return this.getSplitDefinition();
		case 78:
			return this.getRegularAggregate();
		case 249:
			return this.getFacetDefinition();
		case 250:
			return this.getDatatypeCategory();
		case 251:
			return this.getPromptInfo();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 3:
			return this.basicGetItem();
		case 43:
			return this.getExpression();
		case 244:
			return this.getRole();
		case 74:
			return this.isNullable();
		case 46:
			return this.getSourceCategory();
		case 75:
			return this.getHighlevelDatatype();
		case 58:
			return this.getInstanceType();
		case 77:
			return this.getUsage();
		case 245:
			return this.getFormat();
		case 246:
			return this.basicGetTaxonomy();
		case 247:
			return this.getAggregateMode();
		case 36:
			return this.getRef();
		case 64:
			return this.getDatatype();
		case 248:
			return this.basicGetSplitDefinition();
		case 78:
			return this.getRegularAggregate();
		case 249:
			return this.getFacetDefinition();
		case 250:
			return this.getDatatypeCategory();
		case 251:
			return this.getPromptInfo();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 3:
			this.addItemAt(position, (value));
			break;
		case 246:
			this.addTaxonomyAt(position, (value));
			break;
		case 248:
			this.addSplitDefinitionAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 3:
			this.addItem((value));
			break;
		case 246:
			this.addTaxonomy((value));
			break;
		case 248:
			this.addSplitDefinition((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 3:
			this.removeItemAt(position);
			break;
		case 246:
			this.removeTaxonomyAt(position);
			break;
		case 248:
			this.removeSplitDefinitionAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 3:
			this.removeItem((item));
			break;
		case 246:
			this.removeTaxonomy((item));
			break;
		case 248:
			this.removeSplitDefinition((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}

	/**
	 * Set the resolved object based on reference.
	 * @param {MoserObject} referencedObject the referenced <code>MoserObject</code>
	 */
	setReferencedObject(referencedObject) {
		this._referencedObject = referencedObject;
	}

	/**
	 * Get the resolved object based on reference.
	 * @return {MoserObject} the referenced <code>MoserObject</code>
	 */
	getReferencedObject() {
		return this._referencedObject;
	}

	clone() {
		var cloned = (super.clone());
		cloned.setReferencedObject(this._referencedObject);
		return cloned;
	}
}


// WEBPACK FOOTER //
// ./src/generated/BaseQueryItemType.js